import React, { useContext, useEffect, useRef, useState } from 'react';

import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';

import { State } from '../Provider';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import UI from '../lib.r2/ui/ui-controls';

import './LoginPage.scss';
import { StyleButton } from '../Assets';
import Sys from '../lib.r2/utils/SystemUtils';


// ---------------------------------------------------------------------------- LoginPage
export default function LoginPage(props){
	const state = useContext(State);
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState('');

	const nameRef = useRef();
	const pwRef = useRef();
	

	const onLogin = e => {
		checkLogin(nameRef.current.value, pwRef.current.value)
	}


	useEffect(() => {	//init
		let user = sessionStorage.getItem('user')
		if (user) user = JSON.parse(user)

		if (user) props.onLogin(user) //init login
	}, [])


	// ------------------------------------------------------------------------ checkLogin
	const checkLogin = async (usr, pw) => {
		let url = state.config.api.url + 'login'
		let result = await Sys.fetch(url, {
			method : 'POST',
			body	: JSON.stringify({
				email:usr,
				password:pw,
			}),
			headers	: {'content-type' : 'application/json; charset=utf-8'}
		})

		if (!result?.user) return setError('Login Error!')

		result.user._token = result.token
		sessionStorage.setItem('user', JSON.stringify(result.user))

		props.onLogin(result.user);
	}


	return (
		<div id='_login-page'>
			<img className='app-logo' src={'assets/KNAPP_Logo_White_300.png'} alt='' />
			<div className='login-title'>GENOMIX LOGIN</div>

			<FormControl>
				<Grid container spacing={1} alignItems="flex-end" sx={{ m: 1 }}>
					<UI.Icon className='app-icon' image={'assets/icons/user.png'} width={40} height={40} padding={5} />

					<Grid item>
						<TextField
							id="input-with-icon-grid"
							label={global.getLabel('login', 'username')}
							autoComplete='off'
							style={{fontSize:16, width:400}}
							inputRef={nameRef}
							inputProps={{
								style: {
									paddingTop: 10,
									paddingBottom: 10
								}
							}}
							error={error !== ''}
							onKeyPress={e => {if (e.key === 'Enter') onLogin()}}
						/>
					</Grid>
				</Grid>

				<Grid container spacing={1} alignItems="flex-end" sx={{ m: 1 }}>
					<UI.Icon className='app-icon' image={'assets/icons/lock.png'} width={40} height={40} padding={5} />

					<Grid item id='password-grid-item'>
						<TextField
							id="input-with-icon-grid"
							label={global.getLabel('password', 'password')}
							autoComplete='new-password'
							style={{fontSize:16, width:400}}
							inputRef={pwRef}
							inputProps={{
								style: {
									paddingTop: 10,
									paddingBottom: 10
								}
							}}
							error={error !== ''}
							onKeyPress={e => {if (e.key === 'Enter') onLogin()}}
							type={showPassword? 'text' : 'password'}
						/>
						<div className='show-password'>
							<IconButton onClick={e => setShowPassword(!showPassword)}>
								{showPassword ? <Visibility /> : <VisibilityOff />}
							</IconButton>
						</div>
					</Grid>
				</Grid>

				<div className='input-error'>{error}</div>
			</FormControl>

			<div style={{display:'flex'}}>
			<StyleButton
				icon='check'
				onClick={onLogin}
				style={{marginTop:'40px'}}
			/>

			{state.isDebug &&
				<StyleButton
					label='Connect'
					onClick={props.onConnect}
					style={{marginTop:'40px'}}
				/>
			}
			</div>
		</div>
	)
}
